import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DocumentVersion } from '../../model/document-version.model';
import { WkCompareService } from '../../services/wk-compare.service';
import { getAppSelection } from '../../store/selectors/app.custom-selectors';
import { AppStore } from '../../store/states/app.state';
@Component({
  selector: 'wk-compare-documents',
  templateUrl: './wk-compare-documents.component.html',
  styleUrls: ['./wk-compare-documents.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkCompareDocumentsComponent implements OnInit {
  @Output() documentsSelected = new EventEmitter<{
    current: DocumentVersion;
    target: DocumentVersion;
  }>();
  fileName: string;
  compareDoc: DocumentVersion = null;
  compareWithDoc: DocumentVersion = null;
  compare: DocumentVersion[];
  compareWith: DocumentVersion[];
  parentId: string;
  id: string;
  @Input()
  entryId: string;
  onDestroy = new Subject<any>();

  constructor(
    private readonly compareService: WkCompareService,
    private readonly store: Store<AppStore>,
    private readonly datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.store
      .select(getAppSelection)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(({ file }) => {
        if (file) {
          this.fileName = file.entry.name;
          this.parentId = file.entry.parentId;
          this.currentDocument(file.entry.id);
        }
      });
    this.compareService
      .getChosenNodes()
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        if (data && data[0].isFile === true) {
          this.targetDocument(data);
        }
      });
    this.compareService
      .getTargetDocument()
      .pipe(takeUntil(this.onDestroy))
      .subscribe((targetDocument) => {
        if (targetDocument) {
          this.compareWith = [];
          this.compareWith.push(targetDocument);
        }
      });
  }

  currentDocument(id: string): void {
    this.compareService
      .getVersions(`workspace://SpacesStore/${id}`)
      .subscribe((versions: DocumentVersion[]): void => {
        const documentCompare = versions.map((el) => ({
          ...el,
          name: this.fileName,
          checkedIn: this.datePipe.transform(el.checkedIn, 'short'),
        }));
        this.compare = [];
        this.compare.push(documentCompare[0]);
        this.compareService
          .getCurrentDocument()
          .subscribe((currentDocument) => {
            if (currentDocument) {
              this.compare = [];
              this.compare.push(currentDocument);
            }
          });
        this.emitEvent();
      });
  }

  targetDocument(data) {
    this.compareService
      .getVersions(`workspace://SpacesStore/${data[0].id}`)
      .subscribe((versions: DocumentVersion[]): void => {
        const docName = versions.map((el) => ({ ...el, name: data[0].name }));
        this.compareWith = [];
        this.compareWith.push({
          ...docName[0],
          checkedIn: this.datePipe.transform(docName[0].checkedIn, 'short'),
        });
        this.emitEvent();
      });
  }

  swap(compare, compareWith) {
    if (this.compare && this.compareWith) {
      this.compare = compareWith;
      this.compareWith = compare;
      this.emitEvent();
    }
  }

  emitEvent(): void {
    if (this.compare && this.compareWith) {
      this.documentsSelected.emit({
        current: this.compare[0],
        target: this.compareWith[0],
      });
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(true);
    this.onDestroy.complete();
    this.compareService.setTargetDocument('');
    this.compareService.setCurrentDocument('');
  }
}
